import React from "react";
import '../assets/css/accueil.css'
import {Header,CarouselLogo} from '@agam_marseille/package_composants_generiques'

function Accueil() {
  let titre = "Ecosystème de la filière jeux vidéo"
  let titreMaj = titre.toUpperCase()
  return (
    <Header
      titre={titreMaj}
      // sousTitre={"Ecosystème de la filière jeux vidéo"}
    >
      <CarouselLogo
        // fos
        amp
        // cciamp
        // dept13
        // etat
        // euroMed
        // marseille
        // regionSud
      />
    </Header >
  );
}
export default Accueil;